import { Icon } from "./Icon.tsx";

/** "Herramientas" menu trigger icon — a wrench, the generic "tools" glyph. */
export function ToolsMenuIcon() {
  return (
    <Icon>
      <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94Z" />
    </Icon>
  );
}
